import { render } from "./Onboard.vue?vue&type=template&id=2370b6a6&scoped=true&ts=true"
import script from "./Onboard.vue?vue&type=script&lang=ts"
export * from "./Onboard.vue?vue&type=script&lang=ts"

import "./Onboard.vue?vue&type=style&index=0&id=2370b6a6&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2370b6a6"]])

export default __exports__